import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
    return(
        <div>
            <p className={styles.copy}>&copy;2022 By Jhonatan Prado</p>
        </div>
    )
}